import {searchAndTranslateI18n, showSnackbar, toggleLoadingBar} from "./Utils.js";

export default class Data
{
    demoSignIn(payload) {
        return this.run('/api/demoSignIn', payload, {method: 'POST'});
    }

    deleteFAQItem(id) {
        return this.run('/api/help/faq/' + id, {}, {method: 'DELETE'});
    }

    addFAQ(payload) {
        return this.run('/api/help/faq', payload, {method: 'POST'});
    }

    editFAQ(id, payload) {
        return this.run('/api/help/faq/' + id, payload, {method: 'POST'});
    }

    scanner(payload) {
        return this.run('/api/scanner', payload, {method: 'POST'});
    }

    submitFeedback(feedback) {
        return this.run('/api/help/feedback', {feedback}, {method: 'POST'});
    }

    submitContactSupport(payload) {
        return this.run('/api/help/contactSupport', payload, {method: 'POST'});
    }

    cancelDeletionOfAccount() {
        return this.run('/api/account/cancelDeletion', {}, {method: 'POST'});
    }

    changeDefaultLanguage(languageCode) {
        return this.run('/api/account/changeDefaultLanguage', {code: languageCode}, {method: 'POST'});
    }

    checkedIntro() {
        return this.run('/api/account/intro', {}, {method: 'POST'});
    }

    deleteAccount(password) {
        return this.run('/api/account', {password}, {method: 'DELETE'});
    }

    editCategory(payload) {
        return this.run('/api/categories', payload, {method: 'POST'});
    }

    deleteTemplate(transactionId, position) {
        return this.run('/api/transactionTemplates/' + transactionId, {position}, {method: 'DELETE'});
    }

    transactionTemplateSave(payload) {
        return this.run('/api/transactionTemplates', payload, {method: 'POST'});
    }

    transactionTemplateUpdate(templateId, payload) {
        return this.run('/api/transactionTemplates/' + templateId, payload, {method: 'POST'});
    }

    transactionToggleStatus(transactionId, approved) {
        return this.run('/api/transactions/' + transactionId + '/toggleStatus', {approved}, {method: 'POST'});
    }

    swapTransactionTemplatePositions(params) {
        return this.run('/api/transactionTemplates/swap', params, {method: 'POST'});
    }

    templateByPosition(position) {
        return this.run('/api/transactionTemplates/position/' + position, {}, {method: 'GET'});
    }

    transactionTemplates(payload) {
        return this.run('/api/transactionTemplates/all', payload, {method: 'POST'});
    }

    createTransactionFromTemplate(id) {
        return this.run('/api/transactionTemplates/' + id + '/asTransaction', {}, {method: 'POST'});
    }

    newTransactionTemplate(payload) {
        return this.run('/api/transactionTemplates', payload, {method: 'POST'});
    }

    deleteTransaction(transactionId) {
        return this.run('/api/transactions/' + transactionId, {}, {method: 'DELETE'});
    }

    deleteSpace(spaceId) {
        return this.run('/api/spaces/' + spaceId, {}, {method: 'DELETE'});
    }

    deleteCategory(categoryId) {
        return this.run('/api/categories/' + categoryId, {}, {method: 'DELETE'});
    }

    archive(payload) {
        return this.run('/api/categories/archive', payload, {method: 'POST'});
    }

    rearrange(payload) {
        return this.run('/api/categories/rearrange', payload, {method: 'POST'});
    }

    notes(payload) {
        return this.run('/api/notes/all', payload, {method: 'POST'});
    }

    addNote(note, name) {
        return this.run('/api/notes', {note, name}, {method: 'POST'});
    }

    editNote(noteId, note, name) {
        return this.run('/api/notes/' + noteId, {note, name}, {method: 'POST'});
    }

    deleteNote(noteId) {
        return this.run('/api/notes/' + noteId, {}, {method: 'DELETE'});
    }

    updateBudget(payload) {
        return this.run('/api/budgets', payload, {method: 'POST'});
    }

    transactionById(transactionId) {
        return this.run('/api/transactions/' + transactionId, {}, {method: 'GET'});
    }

    transactions(payload) {
        return this.run('/api/transactions/all', payload, {method: 'POST'});
    }

    transactionsList(payload) {
        return this.run('/api/transactions/list', payload, {method: 'POST'});
    }

    toggleMonthStatus(payload, year, month) {
        return this.run('/api/budgets/toggleMonth/' + year + '/' + month, payload, {method: 'POST'});
    }

    deleteScheduledTransaction(id) {
        return this.run('/api/scheduledTransactions/' + id, {}, {method: 'DELETE'});
    }

    scheduledTransactionSave(payload) {
        return this.run('/api/scheduledTransactions', payload, {method: 'POST'});
    }

    scheduledTransactionUpdate(id, payload) {
        return this.run('/api/scheduledTransactions/' + id, payload, {method: 'POST'});
    }

    scheduledTransactionById(transactionId) {
        return this.run('/api/scheduledTransactions/' + transactionId, {}, {method: 'GET'});
    }

    scheduledTransactionToggleActive(transactionId, active) {
        return this.run('/api/scheduledTransactions/' + transactionId + '/toggleActive', {active}, {method: 'POST'});
    }

    scheduledTransactionToggleAutoApprove(transactionId, autoApprove) {
        return this.run('/api/scheduledTransactions/' + transactionId + '/toggleAutoApprove', {auto_approve: autoApprove}, {method: 'POST'});
    }

    transactionSave(payload) {
        return this.run('/api/transactions', payload, {method: 'POST'});
    }

    transactionUpdate(transactionId, payload) {
        return this.run('/api/transactions/' + transactionId, payload, {method: 'POST'});
    }

    switchSpace(payload) {
        return this.run('/api/spaces/switch', payload, {method: 'POST'});
    }

    changePassword(payload) {
        return this.run('/api/account/changePassword', payload, {method: 'POST'});
    }

    resendVerificationEmail(payload) {
        return this.run('/api/resendVerificationEmail', payload, {method: 'POST'});
    }

    passwordResetLink(email) {
        return this.run('/api/passwordResetLink', {email}, {method: 'POST'});
    }

    setNewPassword(payload) {
        return this.run('/api/setNewPassword', payload, {method: 'POST'});
    }

    updateAccountSettings(payload) {
        return this.run('/api/account/settings', payload, {method: 'POST'});
    }

    newSpace(payload) {
        return this.run('/api/spaces', payload, {method: 'POST'});
    }

    signIn(payload) {
        return this.run('/api/auth', payload, {method: 'POST'});
    }

    signUp(payload) {
        return this.run('/api/signUp', payload, {method: 'POST'});
    }

    async run(url, payload = {}, options = {}) {
        toggleLoadingBar();

        delete payload['cf-turnstile-response'];

        if (!(payload instanceof FormData)) {
            payload = Object.fromEntries(
                Object.entries(payload).map(([key, value]) => [
                    key,
                    value === '' ? null : value
                ])
            );
        }

        const turnstileToken =
            (typeof turnstile !== 'undefined' ? turnstile.getResponse() : '') ||
            document.querySelector('[name="cf-turnstile-response"]')?.value ||
            '';

        let defaultOptions = {
            method: 'GET',
            withCredentials: true,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
            }
        };

        if (turnstileToken) {
            defaultOptions.headers['X-CF-TOKEN'] = turnstileToken;
        }

        if (payload instanceof FormData) {
            delete defaultOptions.headers['Content-Type'];
            defaultOptions.body = payload;
        } else {
            if (Object.keys(payload).length) {
                if (!options.hasOwnProperty('method') || options.method === 'GET') {
                    url += '?' + (new URLSearchParams(payload)).toString();
                } else {
                    defaultOptions.body = JSON.stringify(payload);
                }
            }
        }

        const response = await fetch(url, {...defaultOptions, ...options});

        toggleLoadingBar();

        if (!response.headers.get('content-type')?.includes('application/json')) {
            throw new Error('Unexpected content type');
        }

        let originalJson = await response.json();
        let json = searchAndTranslateI18n(originalJson);

        if (json.status !== 'success' || json.status === 'success' && json.error === true) {
            if (!json.hasOwnProperty('redirect')) {
                if (json.hasOwnProperty('display') && json.display) {
                    showSnackbar(json.data);

                    // quick and dirty workaround
                    if (originalJson.data === 'i18n.text_milo_account_is_read_only') {
                        if ('active_modal' in BS_EVENTS && typeof BS_EVENTS.active_modal !== "undefined") {
                            BS_EVENTS.active_modal.close();
                        }

                        document.querySelectorAll('.toggle').forEach(i => i.style.pointerEvents = 'none');
                    }
                }
            } else {
                window.location.href = json.redirect;
            }
        }

        if (typeof turnstile !== 'undefined' && typeof json.reset_captcha !== "undefined" && json.reset_captcha) {
            document.querySelector('.captcha-container').classList.remove('show');
            document.querySelector('.captcha-container').classList.add('error');
            document.querySelector('[data-wait-captcha]')?.classList.add('button--loading');
            turnstile.reset();
        }

        return json;
    }
}